import React from "react";
import { motion } from "framer-motion";

export const scrollToPricing = () => {
  const el = document.getElementById("pricing");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Check = ({ className = "" }) => (
  <svg className={`w-5 h-5 ${className}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <circle cx="12" cy="12" r="10" opacity="0.25" />
    <path d="M8 12l3 3 5-6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Eyebrow = ({ children, className = "" }) => <div className={`bps-eyebrow ${className}`}>{children}</div>;

export const ChevronLeft = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M15 18l-6-6 6-6" strokeLinecap="round" strokeLinejoin="round" /></svg>
);
export const ChevronRight = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M9 18l6-6-6-6" strokeLinecap="round" strokeLinejoin="round" /></svg>
);
export const Glow = ({ className = "" }) => (
  <div className={`pointer-events-none absolute rounded-full blur-[120px] ${className}`} aria-hidden />
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 26 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.6, delay, ease: [0.21, 0.5, 0.27, 0.95] }}
  >
    {children}
  </motion.div>
);

export const Band = ({ id, children, className = "", tone = "base" }) => (
  <section id={id} className={`relative px-5 sm:px-8 py-12 lg:py-16 ${tone === "alt" ? "bps-section-alt" : ""} ${className}`}>
    <div className="relative max-w-7xl mx-auto">{children}</div>
  </section>
);

export const StarRow = ({ className = "w-4 h-4" }) => (
  <div className="flex gap-0.5 text-[#F59E0B]">
    {[...Array(5)].map((_, s) => (
      <svg key={`star-${s}`} className={className} viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3 6.5 7 .9-5 4.8 1.3 6.8L12 17.8 5.4 21l1.3-6.8-5-4.8 7-.9z"/></svg>
    ))}
  </div>
);

export const PrimaryCTA = ({ children = "Get Instant Access", sub, testid, className = "" }) => (
  <button
    onClick={scrollToPricing}
    data-testid={testid}
    className={`group inline-flex flex-col rounded-xl text-left px-8 py-5 bg-gradient-to-r from-[#F59E0B] to-[#F97316] text-white shadow-[0_14px_44px_rgba(249,115,22,0.45)] hover:shadow-[0_18px_56px_rgba(249,115,22,0.6)] hover:-translate-y-0.5 transition-all ${className}`}
  >
    <span className="font-display text-lg sm:text-xl font-extrabold tracking-tight uppercase flex items-center gap-3">
      {children}
      <svg className="w-5 h-5 transition-transform group-hover:translate-x-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round"/></svg>
    </span>
    {sub && <span className="text-[11px] tracking-[0.22em] font-semibold opacity-90 mt-1 uppercase">{sub}</span>}
  </button>
);
